import React from "react";
import { useNavigate, useLocation } from "react-router-dom";


const FindEmployee = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if the current URL is /enumerator/about
  if (location.pathname === "/enumerator/about") {
    return null; // Do not render the component
  }

  return (
    <>
      <div className="my-16 p-16 bg-secondary">
        <div className=" max-w-6xl mx-auto flex flex-col lg:flex-row justify-between items-center">
          <div>
            <h3 className="text-3xl md:text-3xl font-bold  text-black text-lg mb-2">
              Find Employee
            </h3>
            <p
              className="text-xl mb-8"
              data-aos="zoom-y-out"
              data-aos-delay="150"
              style={{ color: "#637381" }}
            >
              Before finding your employee you must setup your company profile.
            </p>
          </div>
          <button
            className="btn-sm text-white bg-green-600 hover:bg-green-600 ml-3 px-5 py-3 rounded-lg cursor-pointer"
            onClick={() => navigate("/register")}
          >
            <span>Create an account</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default FindEmployee;
